import { createAction } from 'lib/store-utils';
import { PageId } from './types';

export const BOX_FETCH_PAGE_DATA_REQUEST = createAction<PageId>('Fetch page data / request');
export const BOX_FETCH_PAGE_DATA_SUCCESS = createAction<PageId>('Fetch page data / success');
export const BOX_FETCH_PAGE_DATA_FAILURE = createAction<PageId>('Fetch page data / failure');

export const BOX_FETCH_PAGE_DATA_CLEAR_IS_FETCHED = createAction<PageId>('Fetch page data / clear is fetched state');
